<template>
<body id="page-top" class="body-bg">
        <Nav/>
        <section class="page-section portfolio" id="portfolio">
            <div class="container cpt-10">
                <!-- Portfolio Grid Items-->
                <div class="row justify-content-center">
                    
                    <!-- Portfolio Item 2-->
                    <div class="col-md-6 col-lg-4 mb-5">
                        <div class="portfolio-item mx-auto" data-bs-toggle="modal" data-bs-target="#portfolioModal2">
                            <div class="d-flex align-items-center justify-content-center h-100 w-100">
                                <div class="portfolio-item-caption-content text-center text-white"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <a class="btn mb-login-btn"><router-link to="/options-login">  <img class="img-fluid" src="../assets/Type-the-certificate.png" alt="..." /> </router-link></a>
                            <p class="h3">Type the Certificate no., Name, Birthdate</p>
                        </div>
                    </div>
                    <div class="col-md-12" style="text-align: center;">
                            <router-link to="/login"><button class="btn btn-primary btn-lg">BACK</button></router-link>
                        </div>
                    </div>
                       <b-modal ref="my-modal" id="modal-center" content-class="customer-adv-modal terms-modal scroll" centered title="">
                       <p>Heyphil DigiMed and Smart LOA Data Privacy</p>
                       <p class="terms-conditions">We take your privacy seriously, and we want you to know how we collect, use, share and protect your information. 
                        In addition to this Privacy Policy, users of the PhilCare Site/App should consult the PhilCare Terms and Conditions 
                        of use as well as any product specific terms and conditions that apply.<br>This policy applies to PhilCare.com.ph and other Web locations under PhilCare's control.
                        <br><br><strong>What Information We Collect</strong><br><br>We respect the right to privacy of all visitors to the PhilCare Site/App. We do not collect information that would personally 
                        identify you unless you choose to provide it. For example, if you choose to join the community at the PhilCare Online Community, the Privacy Policy and Terms and 
                        Conditions of use of that site/app apply. The personal information that you submit is shared only with those people in the PhilCare organization who need this 
                        information to respond to your question or request. Information submitted through PhilCare Site/App's online forms may be collected to ensure technical functionality. 
                        It will also be utilized to address any inappropriate use of our website/app. We do not save personal information to use for other purposes, nor do we provide it to any 
                        other organizations.<br><br><strong>Email Communications, Newsletter, and Related Services</strong><br><br>Upon your consent and approval, PhilCare.com.ph provides you with the opportunity 
                        to receive communications from us or third parties. You can sign up for a free email newsletter. You can unsubscribe from this newsletter at any time. <br><br> Email 
                        communications that you send to us via the email links on our site/app may be shared with a customer service representative, employee, medical expert or agent that is most 
                        able to address your inquiry. We make every effort to respond in a timely fashion once communications are received. Once we have responded to your communication, it is 
                        discarded or archived, depending on the nature of the inquiry.<br><br> The email functionality on our site/app does not provide a completely secure and confidential means 
                        of communication. It's possible that your email communication may be accessed or viewed by another Internet user while in transit to us. If you wish to keep your 
                        communication private, do not use our email.<br><br> You may decide at some point that you no longer wish to receive communications from our site/app. To stop receiving 
                        communications, send an email message to customercare@philcare.com.ph or send regular mail to the following postal address:<br><br>PhilCare Website Master<br> 5/F STI 
                        Holdings Center Building <br>6764 Ayala Avenue<br>Makati City, Philippines</p>
                       <button style="margin-right:10px;" @click='agreeBtn'>I Agree</button>     
                       <button style="margin-left:10px;" @click='disagreeBtn'>I Disagree</button>          
                  </b-modal>
                </div>
             
        </section>
</body>
</template>

<script>
import Nav from '../components/Includes/NavComponent.vue'
export default {
    
  name: 'PhilLogin',
  props: {
    msg: String
  },
  components: {
    Nav
  },

  mounted() {
    this.showModal()
    console.log('modal');
  },

  methods: {

    showModal() {
            this.$refs['my-modal'].show()
          },
          show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
          
        },
        agreeBtn() {
        this.$refs['my-modal'].hide()
        },
        disagreeBtn() {
        this.$router.push('/');
        }
  },
  
  
}

</script>

<style>
.terms-modal .close {
  display: none;
}

.terms-modal{
    height: 94vh !important;
    overflow: auto !important;
}

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
